import { Button } from '@design-system';
import { ShopInsuranceLicensingSheet } from '@/features/shop-insurance';

export function ShopInsuranceNotice() {
  return (
    <div className="text-foreground text-start text-xs">
      <p>
        <strong>Insurance & Licensing Notice:</strong> Insurance products and quotes are offered
        through Wealth Assurance Group, LLC, a wholly owned subsidiary of Waterlily, licensed for
        life, health and long-term-care insurance in 50 states and the District of Columbia. Not all
        products are available in every state. If a product is purchased, the producer(s) on your
        application may receive commission based on a percentage of paid premiums, which varies by
        product and state. If Wealth Assurance Group serves as a producer on your application, they
        may receive part or all of that commission. State-specific commission disclosures are
        available upon request.
      </p>

      <ShopInsuranceLicensingSheet>
        <Button
          variant="link"
          className="mt-2 h-auto p-0 text-xs font-medium text-gray-700 underline hover:text-gray-900"
        >
          Learn More
        </Button>
      </ShopInsuranceLicensingSheet>
    </div>
  );
}
